import { formatEntityName } from "../utils/formatters/stringFormatter";

export const buildInitialNodes = (resolvedFields) => {
  const safeFields = Array.isArray(resolvedFields) ? resolvedFields : [];

  const sourceFields = safeFields.filter((f) => f.type === 'source');
  const destFields = safeFields.filter((f) => f.type === 'destination');

  // const sourceNodesCount = new Set(sourceFields.map(f => f.node_id)).size;
  // const destNodesCount = new Set(destFields.map(f => f.node_id)).size;
  // const isOneToOne = sourceNodesCount === 1 && destNodesCount === 1;

  console.log('sourceFields:::', sourceFields)
  console.log('destFields:::', destFields)

  function groupBy(arr, key) {
    return arr.reduce((acc, item) => {
      const val = item[key];
      if (!acc[val]) acc[val] = [];
      acc[val].push(item);
      return acc;
    }, {});
  }

  // const transformFields = (fields) => {
  //   console.log('transformFields called with:', fields);

  //   const grouped = fields.map((f) => ({
  //     id: f.entity || 'UnknownEntity',
  //     label: formatEntityName(f.entity),
  //     children: (Array.isArray(f.fields.fields) ? f.fields.fields : []).map(
  //       (field) => ({
  //         id: `${f.entity || 'UnknownEntity'}__${field.field_name}`,
  //         label: field.field_label || field.field_name,
  //         type: field.data_type || 'string',
  //         is_mandatory: field.is_mandatory,
  //         is_creatable: field.is_creatable,
  //         is_queryable: field.is_queryable,
  //         is_updatable: field.is_updatable,
  //       })
  //     ),
  //   }));

  //   return grouped;
  // };

  const buildEntityGroups = (entitiesArr, nodeId) => {
    console.log('transformFields called with:', entitiesArr);

    return entitiesArr.map((entity) => ({
      id: `${nodeId}__${entity.entity || 'UnknownEntity'}`,
      label: formatEntityName(entity.entity),
      children: (Array.isArray(entity.fields.fields) ? entity.fields.fields : []).map(
        (field) => {
          console.log('  Field:', field.field_name, field);
          return {
            id: `${nodeId}__${entity.entity || 'UnknownEntity'}__${field.field_name}`,
            label: field.field_label || field.field_name,
            type: field.data_type || 'string',
            is_mandatory: field.is_mandatory,
            is_creatable: field.is_creatable,
            is_queryable: field.is_queryable,
            is_updatable: field.is_updatable,
            nodeId,
          };
        }
      ),
    }));
  };


  // if (isOneToOne) {

  //   return [
  //     {
  //       id: 'source1',
  //       type: 'sourceNode',
  //       position: { x: -400, y: 250 },
  //       data: {
  //         label: 'Source Entity',
  //         type: 'source',
  //         subFields: transformFields(sourceFields),
  //       },
  //     },
  //     {
  //       id: 'destination1',
  //       type: 'destinationNode',
  //       position: { x: 1180, y: 250 },
  //       data: {
  //         label: 'Destination Entity',
  //         type: 'destination',
  //         subFields: transformFields(destFields),
  //       },
  //     },
  //   ];

  // } else {

    const baseX = -400;
    const baseY = 150;
    const fieldRowHeight = 46;
    const entityHeaderHeight = 48;
    const nodePadding = 32;
    const betweenNodesY = 100;

    console.log('sourcefieldsss:', sourceFields)

    const groupedSource = groupBy(sourceFields, 'node_id');
    const groupedDest = groupBy(destFields, 'node_id');

    console.log('Grouped Source:', groupedSource);
    console.log('Grouped Dest:', groupedDest);

    let currentSourceY = baseY;
    const sourceNodes = Object.entries(groupedSource).map(([nodeId, group]) => {
      const totalFields = group.reduce((sum, ent) => sum + (ent.fields?.fields?.length || 0), 0);
      const estimatedHeight = entityHeaderHeight + totalFields * fieldRowHeight + nodePadding;

      const node = {
        id: nodeId,
        type: 'sourceNode',
        position: { x: baseX, y: currentSourceY },
        data: {
          label: group.map(ent => formatEntityName(ent.entity)).join(', '),
          type: 'source',
          subFields: buildEntityGroups(group, nodeId),
        },
      };
      currentSourceY += estimatedHeight + betweenNodesY;
      console.log('nodeee:', node)
      return node;
    });

    let currentDestY = baseY;
    const destinationNodes = Object.entries(groupedDest).map(([nodeId, group]) => {
      const totalFields = group.reduce((sum, ent) => sum + (ent.fields?.fields?.length || 0), 0);
      const estimatedHeight = entityHeaderHeight + totalFields * fieldRowHeight + nodePadding;

      const node = {
        id: nodeId,
        type: 'destinationNode',
        position: { x: 1180, y: currentDestY },
        data: {
          label: group.map(ent => formatEntityName(ent.entity)).join(', '),
          type: 'destination',
          subFields: buildEntityGroups(group, nodeId),
        },
      };
      currentDestY += estimatedHeight + betweenNodesY;
      return node;
    });

    return [...sourceNodes, ...destinationNodes];

  // }
};
